angular.module('rjmNg.api').factory("accessGroupService", [
  "$resource"
  "phpServiceUrl"
  "app"
  ($resource, phpServiceUrl, app) ->

    actions =
      stores:
        method: 'GET'
        isArray: false
      groups:
        method: 'GET'
        isArray: false
      save:
        method: 'POST'
        # url: phpServiceUrl("/client/#{app.getClientId()}/user/:id")
      edit:
        method: 'PUT'
      delete:
        method: 'DELETE'
      forceDelete:
        method: 'DELETE'

    accessGroupStoreService = $resource(phpServiceUrl("/client/#{app.getClientId()}/accessgroups-store"), {}, actions)
    accessGroupNamesService = $resource(phpServiceUrl("/client/#{app.getClientId()}/accessgroups-list"), {}, actions)
    addGroup = $resource(phpServiceUrl("/client/#{app.getClientId()}/accessgroups"), {}, actions)
    editGroup = $resource(phpServiceUrl("/client/#{app.getClientId()}/accessgroups/:groupId"), { groupId: '@groupId' }, actions)
    deleteGroup = $resource(phpServiceUrl("/client/#{app.getClientId()}/accessgroups/:groupId"), { groupId: '@groupId' }, actions)
    forceDeleteGroup = $resource(phpServiceUrl("/client/#{app.getClientId()}/accessgroups/:groupId/force_delete"), { groupId: '@groupId' }, actions)
    {
      stores: (clientId) ->
        accessGroupStoreService.stores({}, clientId).$promise
      groups: (clientId) ->
        accessGroupNamesService.groups({}, clientId).$promise
      save: (user) ->
        addGroup.save({}, user).$promise
      edit: (groupId, user) ->
        editGroup.edit({ groupId: groupId }, user).$promise
      delete: (groupId, user) ->
        deleteGroup.delete({ groupId: groupId }, user).$promise
      forceDelete: (groupId, user) ->
        forceDeleteGroup.forceDelete({ groupId: groupId }, user).$promise
    }
  ]
)
